import React, { useCallback, useEffect, useState } from "react";
import styles from "./index.module.css";
import ReportTablePacingDiamond from "Reporting/Components/ReportTablePacingDiamond";
import { usePacingDiamondGet } from "./usePacingDiamondGet";
import Loader from "shared/Loader";

export default function ReportTableListPacingDiamond({
  filters,
  setReportsLength,
  setReportData,
  fetchTrigger,
}) {
  const { data, isLoading, isError, refetch } = usePacingDiamondGet(filters);
  const [reports, setReports] = useState([]);

  useEffect(() => {
    if (typeof fetchTrigger !== "undefined") {
      refetch?.();
    }
  }, [fetchTrigger]);

  useEffect(() => {
    if (!Array.isArray(data)) return;

    const nextReports = data.map((report) => ({
      ...report,
      rows: [...(report.rows || [])].sort(
        (a, b) => Number(b.isTotalRow) - Number(a.isTotalRow)
      ),
    }));
    setReports(nextReports);

    const reportsWithRows = nextReports.filter(
      (report) => Array.isArray(report.rows) && report.rows.length > 0
    );

    setReportsLength?.(reportsWithRows.length || 0);
    setReportData?.(nextReports);
  }, [data]);

  const handleSortedRowsChange = useCallback((reportIndex, sortedRows) => {
    setReports((current) => {
      const nextReports = current.map((report, index) =>
        index === reportIndex ? { ...report, rows: sortedRows } : report
      );
      if (JSON.stringify(current) === JSON.stringify(nextReports)) {
        return current;
      }
      setReportData?.(nextReports);
      return nextReports;
    });
  }, [setReportData]);

  if (isError) return <div>Something went wrong...</div>;
  if (isLoading) return <Loader />;
  if (reports.length === 0) return <div>No Reports Found</div>;

  return (
    <div className={styles.container}>
      {reports.map((report, index) => (
        <ReportTablePacingDiamond
          report={report}
          key={index}
          onSortedRowsChange={(sortedRows) =>
            handleSortedRowsChange(index, sortedRows)
          }
        />
      ))}
    </div>
  );
}